<script>
/* import */
import { Pie } from 'vue-chartjs';
/* js */
import { CHART_COLOR } from '@/js/properties/config';
export default {

  // ===========================================================================
  // extends
  // ===========================================================================
  extends: Pie,

  // ===========================================================================
  // name
  // ===========================================================================
  name: 'CompoPieChart',

  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      datas: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [
              CHART_COLOR.FAULT,
              CHART_COLOR.ERROR,
              CHART_COLOR.WARNING,
              CHART_COLOR.OK,
              CHART_COLOR.OFFLINE,
            ],
          }
        ]
      },
      options: {
        legend: { display: false },
        responsive: true
      },

      offline: this.$t('UI_DB_OFFLINE'),
    };
  },

  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted() {
    /* Nothing */
  },

  // ===========================================================================
  // created
  // ===========================================================================
  async created() 
  {
    /* Nothing */
  },
  
    // ===========================================================================
  // methods
  // ===========================================================================
  methods : 
  {
    async createDataSet(online, offline) {
      for (let i = 0 ; i < online.length ; i++) {
        this.datas.labels[i] = online[i].status;
        this.datas.datasets[0].data[i] = online[i].count;
      }
      this.datas.labels.push(this.offline);
      this.datas.datasets[0].data.push(offline[0].count);

      // グラフ描画処理
      this.renderChart(this.datas, this.options);
    },
  },
};
</script>

<style scoped>
</style>